import { mobileLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled, { css } from 'styled-components';

export const CheckButton = styled.button<{ $checked: boolean }>`
  flex: 1;
  display: flex;
  border-radius: 30px;
  border: 1px solid ${({ theme }) => theme.keyline};
  padding: 0 15px;
  align-items: center;
  background-color: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.textDark};

  ${({ $checked, theme }) =>
    $checked &&
    css`
      background-color: ${theme.textDark};
      color: ${theme.white};
      border: 1px solid ${theme.textDark};
      font-weight: bold;

      img {
        filter: brightness(100);
      }
    `}

  img {
    width: 30px;
    height: 30px;
    margin-left: 5px;
    margin-right: 10px;
  }

  @media (${mobileLargeMax}) {
    img {
      width: 24px;
      height: 24px;
      margin-left: 3px;
    }
  }
`;

export const CheckLabel = styled.div`
  height: 56px;
  border-radius: 4px;
  display: flex;
  align-items: stretch;
  justify-content: center;
  flex-direction: column;
  width: 100%;
`;

export const CheckText = styled.span`
  font-size: 14px;
  text-align: center;
`;

export const CheckSubText = styled.span`
  font-size: 12px;
  text-align: left;
`;
